export default __webpack_public_path__ + "static/media/k_wdt_c_6_7.ddc187e0.mp3";